import { ThemedDateRangeField } from "@vega-core/components/Form/Controls/DateField/ThemedDateRange";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import {
  type DateRangeFilterConfig,
  type FilterState,
  FilterType,
  type FilterValue,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type Props = {
  filter: DateRangeFilterConfig;
  isLoading: boolean;
  filterState: FilterState;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
  disabled?: boolean;
};

export function DateRangeFilter({
  filter,
  isLoading,
  filterState,
  onFilterChange,
  showLabel,
  tableId,
  disabled = false,
}: Props) {
  const shouldShowLabel = filter.showLabel ?? showLabel;
  const isFullWidth = filter.props?.fullWidth ?? false;

  return (
    <ThemedDateRangeField
      {...filter.props}
      className={cnTwMerge(
        isFullWidth ? "w-full" : "w-fit",
        filter.props?.className,
      )}
      disabled={Boolean(filter.props?.disabled || isLoading || disabled)}
      fullWidth={isFullWidth}
      key={filter.id}
      label={shouldShowLabel ? filter.label : undefined}
      name={`${tableId}-${filter.id}`}
      onChange={(range) => onFilterChange(filter.id, range)}
      value={getFilterValue(filterState, filter.id, FilterType.DateRange)}
    />
  );
}
